function MFRBlogGrid(index, element) {
  this.$element = $(element)

  this.selectors = {
    gridContainer: ".section-grid",
    filterContainer: ".section-filter",
    slider: ".slider",
    filter: ".filter-item",
    arrowNext: ".flckty-next",
    arrowPrevious: ".flckty-prev"
  }

  this.blogSliderOptions = {
    pageDots: false,
    contain: true,
    cellAlign: 'left',
    groupCells: true
  }

  this.filtersliderOptions = {
    pageDots: false,
    contain: true,
    groupCells: true
  }

  this.init()
}

MFRBlogGrid.prototype = Object.assign({}, MFRBlogGrid.prototype, {
  init: function () {
    this.$gridContainer = this.$element.find(this.selectors.gridContainer)
    this.$filterContainer = this.$element.find(this.selectors.filterContainer)
    this.$slider = this.$element.find(this.selectors.slider)
    this.$filter = this.$element.find(this.selectors.filter)
    this.$arrowNext = this.$element.find(this.selectors.arrowNext)
    this.$arrowPrevious = this.$element.find(this.selectors.arrowPrevious)
    
    $(window).on("load", this.__handleInitializaton.bind(this))
    $(window).on("resize", this.__handleInitializaton.bind(this))

    this.$arrowNext.on("click", this.__handleSliderChangeEvent.bind(this))
    this.$arrowPrevious.on("click", this.__handleSliderChangeEvent.bind(this))

    this.$filter.on("click", this.__handleSliderFilterChangeEvent.bind(this))
  },

  __handleInitializaton: function() {
    this.__handleSliderInit()
    this.__handleInitialFilterState()
    this.__handleMobileSliderChangeEvent()
    this.__handleFilterOverlapState()
  },

  __handleSliderInit: function() {
    this.$slider.flickity(this.blogSliderOptions)
    this.$filterContainer.flickity(this.filtersliderOptions)
    window.flickityButtonArrowChange()
  },

  __handleFilterOverlapState: function() {
    const filterSlidesCount = this.$filterContainer.data('flickity').slides.length - 1

    this.$filterContainer.on('select.flickity', (event, index) => {
      const $filterSliderViewport = this.$filterContainer.children('.flickity-viewport')
      filterSlidesCount === index ? $filterSliderViewport.addClass('overlap') : $filterSliderViewport.removeClass('overlap')
    })
  },

  __handleInitialFilterState: function() {
    this.$filter.first().click()
  },

  __handleSliderChangeEvent: function(event) {
    const currentEvent = $(event.data).data('event')
    this.$slider.flickity(currentEvent)
  },

  __handleMobileSliderChangeEvent: function() {
    const slidesLength = this.$slider.data('flickity').slides.length - 2

    this.$slider.on('change.flickity', (event, index) => {
      index == 0 ? this.$arrowPrevious.addClass('disable') : this.$arrowPrevious.removeClass('disable')
      index == slidesLength ? this.$arrowNext.addClass('disable') : this.$arrowNext.removeClass('disable')
    })

    this.$arrowPrevious.addClass('disable')
  },

  __handleSliderFilterChangeEvent: function(event) {
    const $currentTarget = $(event.currentTarget)
    const filterValue = $currentTarget.attr('data-filter')
    const $slide = this.$slider.find('.blog-item')
    const active = $('.' + filterValue).fadeIn(500)
    
    $slide.addClass('flickity')
    $slide.not(active).removeClass('flickity').hide()
    $currentTarget.addClass('active').siblings().removeClass('active')

    this.$slider.flickity('destroy')
    this.$slider.flickity(this.blogSliderOptions)
    
    this.__handleSliderFilterNoResults()
  },

  __handleSliderFilterNoResults: function(results) {
    const visibleSlides = this.$slider.find('.blog-item:visible').length
    const $emptyResults = "<p class='no-results'>No matches found.</p>"
    const $noResults = $('.no-results')

    $noResults.remove()
    visibleSlides === 0 ? $($emptyResults).insertAfter(this.$gridContainer) : $noResults.remove()
  }
})